// TRANSITION IMGS HOVER
const displayTransitionsMobile = () => {
  const mascaraTransition01 = document.querySelector('#mascara-zona-mobile-01');
  const mascaraTransition02 = document.querySelector('#mascara-zona-mobile-02');
  const mascaraTransition03 = document.querySelector('#mascara-zona-mobile-03');

  const target01 = document.querySelector('#popover-mobile-01');
  const target02 = document.querySelector('#popover-mobile-02');
  const target03 = document.querySelector('#popover-mobile-03');

  target01.addEventListener('mouseover', () => {
    mascaraTransition01.classList.remove('d-none');

    mascaraTransition02.classList.add('d-none');
    mascaraTransition03.classList.add('d-none');
  });
  target01.addEventListener('mouseleave', () => {
    mascaraTransition01.classList.add('d-none');
    mascaraTransition02.classList.add('d-none');
    mascaraTransition03.classList.add('d-none');
  });

  target02.addEventListener('mouseover', () => {
    mascaraTransition02.classList.remove('d-none');

    mascaraTransition01.classList.add('d-none');
    mascaraTransition03.classList.add('d-none');
  });
  target02.addEventListener('mouseleave', () => {
    mascaraTransition01.classList.add('d-none');
    mascaraTransition02.classList.add('d-none');
    mascaraTransition03.classList.add('d-none');
  });

  target03.addEventListener('mouseover', () => {
    mascaraTransition03.classList.remove('d-none');

    mascaraTransition01.classList.add('d-none');
    mascaraTransition02.classList.add('d-none');
  });
  target03.addEventListener('mouseleave', () => {
    mascaraTransition01.classList.add('d-none');
    mascaraTransition02.classList.add('d-none');
    mascaraTransition03.classList.add('d-none');
  });
}
displayTransitionsMobile();

const displayTransitionsDesktop = () => {
  const mascaraTransition01 = document.querySelector('#mascara-zona-01');
  const mascaraTransition02 = document.querySelector('#mascara-zona-02');
  const mascaraTransition03 = document.querySelector('#mascara-zona-03');

  const target01 = document.querySelector('#popover-01');
  const target02 = document.querySelector('#popover-02');
  const target03 = document.querySelector('#popover-03');

  target01.addEventListener('mouseover', () => {
    mascaraTransition01.classList.remove('d-none');

    mascaraTransition02.classList.add('d-none');
    mascaraTransition03.classList.add('d-none');
  });
  target01.addEventListener('mouseleave', () => {
    mascaraTransition01.classList.add('d-none');
    mascaraTransition02.classList.add('d-none');
    mascaraTransition03.classList.add('d-none');
  });

  target02.addEventListener('mouseover', () => {
    mascaraTransition02.classList.remove('d-none');

    mascaraTransition01.classList.add('d-none');
    mascaraTransition03.classList.add('d-none');
  });
  target02.addEventListener('mouseleave', () => {
    mascaraTransition01.classList.add('d-none');
    mascaraTransition02.classList.add('d-none');
    mascaraTransition03.classList.add('d-none');
  });

  target03.addEventListener('mouseover', () => {
    mascaraTransition03.classList.remove('d-none');

    mascaraTransition01.classList.add('d-none');
    mascaraTransition02.classList.add('d-none');
  });
  target03.addEventListener('mouseleave', () => {
    mascaraTransition01.classList.add('d-none');
    mascaraTransition02.classList.add('d-none');
    mascaraTransition03.classList.add('d-none');
  });
}
displayTransitionsDesktop();

// window.addEventListener('resize', () => {
//   const backgroundDefecto = document.querySelector('#bg-planta-condominio');
//   const mascaraTransition01 = document.querySelector('#mascara-zona-01');
//   const mascaraTransition02 = document.querySelector('#mascara-zona-02');
//   const mascaraTransition03 = document.querySelector('#mascara-zona-03');

//   if(window.innerWidth < 768){
//     backgroundDefecto.src = './build/img/condominio/plano-condominio-sombreado-mobile.webp';
//     mascaraTransition01.src = './build/img/condominio/plano-condominio-etapa-1-sombreado-mobile.webp';
//     mascaraTransition02.src = './build/img/condominio/plano-condominio-etapa-2-sombreado-mobile.webp';
//     mascaraTransition03.src = './build/img/condominio/plano-condominio-zonas-comunes-sombreado-mobile.webp';
//   } 
//   else{
//     backgroundDefecto.src = './build/img/condominio/plano-condominio-sombreado-altos-del-palmar-desktop.webp';
//     mascaraTransition01.src = './build/img/condominio/plano-condominio-etapa-1-sombreado-altos-del-palmar-desktop.webp';
//     mascaraTransition02.src = './build/img/condominio/plano-condominio-etapa-2-sombreado-altos-del-palmar-desktop.webp';
//     mascaraTransition03.src = './build/img/condominio/plano-condominio-zonas-comunes-sombreado-altos-del-palmar-desktop.webp';
//   }
// });


// SLIDER SCRIPTING
$('#sliderCondominio').on('slide.bs.carousel', (event) => {
  const titleSlide = document.querySelector('#titulo-slide');
  const contadorSlide = document.querySelector('#contador-slide');

  if(event.to === 0){
    titleSlide.textContent = 'Zona de relajación tipo Bali';
    contadorSlide.textContent = '1/5';
  }
  else if(event.to === 1){
    titleSlide.textContent = 'Cancha múltiple';
    contadorSlide.textContent = '2/5';
  }
  else if(event.to === 2){
    titleSlide.textContent = 'Zona de masajes';
    contadorSlide.textContent = '3/5';
  }
  else if(event.to === 3){
    titleSlide.textContent = 'Cancha de tenis';
    contadorSlide.textContent = '4/5';
  }
  else if(event.to === 4){
    titleSlide.textContent = 'Casas campestres con diferentes alturas';
    contadorSlide.textContent = '5/5';
  }
  console.log();
})